import React, { useState } from 'react';
import './AdminUsers.css';

const AdminUsers = ({ onVolver }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rol, setRol] = useState('supervisor');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const token = localStorage.getItem('token');

    try {
      const response = await fetch('https://api.interventorsisgafr.com/api/usuarios', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ email, password, rol })
      });

      const newUser = await response.json();
      if (!response.ok) throw new Error(newUser.msg || 'Error al crear usuario');
      
      setSuccess(`¡Usuario ${newUser.email} creado con el rol de ${newUser.rol}!`);
      setEmail('');
      setPassword('');
      setRol('supervisor');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="admin-users-container">
      <button onClick={onVolver} className="volver-btn">&lt; Volver</button>
      <h2>Gestión de Usuarios</h2>
      <form onSubmit={handleSubmit} className="user-form">
        <h3>Crear Nuevo Usuario</h3>
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
        
        <input type="email" placeholder="Email del nuevo usuario" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder="Contraseña temporal" value={password} onChange={e => setPassword(e.target.value)} required />
        <div className="form-group">
          <label>Asignar Rol:</label>
          <select value={rol} onChange={e => setRol(e.target.value)}>
            <option value="admin">Administrador</option>
          </select>
        </div>
        <button type="submit">Crear Usuario</button>
      </form>
      {/* Aquí se podría añadir una lista de usuarios existentes en el futuro */}
    </div>
  );
};

export default AdminUsers;